import { chakra } from '@chakra-ui/react'
import { Modal as VerbitModal } from '@verbit-ai/verbit-ui-library'

export const Modal = VerbitModal

Modal.Header = chakra(VerbitModal.Header, {
    baseStyle: ({ theme }) => ({
        color: theme.palette.verbitModal.titleColor,
    }),
})

Modal.Subtitle = chakra(VerbitModal.Subtitle, {
    baseStyle: ({ theme }) => ({
        color: theme.palette.verbitModal.subtitleColor,
        paddingBottom: 0,
    }),
})

Modal.CloseButton = chakra(VerbitModal.CloseButton, {
    baseStyle: ({ theme }) => ({
        color: theme.palette.verbitModal.closeIconColor,
        _hover: {
            backgroundColor: theme.palette.verbitModal.closeHoverBgColor,
        },
    }),
})
